/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FinancialDeleteFinancialResponse } from "./FinancialDeleteFinancialResponse";

export type FinancialDeleteFinancialResponseApiRespoonse = {
  data?: FinancialDeleteFinancialResponse;
  status?: FinancialDeleteFinancialResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FinancialDeleteFinancialResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
